import React from 'react';
import { Row } from 'talent_matching/types';
import { withLocalePrefix } from 'shared/utils/translation';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { Row as BirchRow } from 'shared/components/birch/row';
import { IconButton } from '@grnhse/seedling/lib/birch/components/buttons';
import BackIcon from '@grnhse/seedling/lib/birch/icons/back';
import ForwardIcon from '@grnhse/seedling/lib/birch/icons/forward';
import styled from 'styled-components';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

const t = withLocalePrefix('talent_matching');

type RowStepperProps = {
  currentIndex: number | null | undefined;
  rowCount: number | undefined;
  previousCandidate: Row | null | undefined;
  nextCandidate: Row | null | undefined;
  selectCandidate: ((row: Row) => void) | undefined;
};

const StepperContainer = styled.div`
  border-top: 1px solid ${FullPalette.GREY_E500};
  display: flex;
  padding: ${Tokens.spacing['2']};
  flex-direction: column;
  align-items: center;
`;

const Row = styled(BirchRow)`
  button {
    &:active,
    &:focus-visible,
    &:focus-within {
      outline: none;
      background-color: unset;
    }
    &:hover:not(:disabled) {
      background-color: ${FullPalette.IRIS_E50};
    }
  }
`;

const RowStepper = ({
  currentIndex,
  rowCount,
  previousCandidate,
  nextCandidate,
  selectCandidate,
}: RowStepperProps) => {
  return (
    <StepperContainer>
      <Row spacing={1} alignItems="center">
        <IconButton
          icon={BackIcon}
          onClick={() =>
            previousCandidate &&
            selectCandidate &&
            selectCandidate(previousCandidate)
          }
          aria-label={t('previous_candidate')}
          label={t('previous_candidate')}
          disabled={!previousCandidate}
        />
        <Body metadata>
          {t('candidate_row_number_of_row_count', {
            row_number: (currentIndex || 0) + 1,
            row_count: rowCount,
          })}
        </Body>
        <IconButton
          icon={ForwardIcon}
          onClick={() =>
            nextCandidate && selectCandidate && selectCandidate(nextCandidate)
          }
          aria-label={t('next_candidate')}
          label={t('next_candidate')}
          disabled={!nextCandidate}
        />
      </Row>
    </StepperContainer>
  );
};

export default RowStepper;
